import {
  GENDER,
  HEALTH_INSURANCE_TYPES,
  LACK_OF_CAPACITY_DOCUMENT,
  LEGAL_GUARDIAN,
  MARITAL_STATUS,
  PRIOR_EMPLOYMENT_STATUS,
  REQUESTED_REHAB_SERVICE,
  REQUESTED_REHAB_SERVICE_TYPE,
  VISUALLY_IMPAIRED_DOCUMENT,
} from "core/consts";
import {
  PENSION_INSURANCE_NUMBER_CHARACTER_LIMIT,
  predicamentSchema,
} from "core/schemas/shared";
import { z } from "zod";

export const DRVGeneralFormSchema = z.object({
  application_submitted: z.string().optional(),
  application_submitted_applicable: predicamentSchema.nullish().optional(),
  before_retirement_pension: z.string().optional(),
  before_retirement_pension_applicable: predicamentSchema.nullish().optional(),
  care_person_necessary: predicamentSchema.nullish().optional(),
  claim_for_damages_approved: predicamentSchema.nullish().optional(),
  claim_for_damages_description: z.number().optional(),
  claim_for_damages_file_number: z.string().optional(),
  claim_for_damages_origin: z.string().optional(),
  consent_of_the_insured: z.enum(LACK_OF_CAPACITY_DOCUMENT).optional(),
  contact_guardian: z.string().optional(),
  contributions_to_foreign_insurance_current: predicamentSchema
    .nullish()
    .optional(),
  contributions_to_foreign_insurance_info: predicamentSchema
    .nullish()
    .optional(),
  contributions_to_foreign_insurance_info_from_to: z.string().optional(),
  contributions_to_foreign_insurance_info_state: z.string().optional(),
  contributions_to_statutory_pension: predicamentSchema.nullish().optional(),
  doctor_in_charge_in_hospital: z.string().optional(),
  doctor_in_charge_in_hospital_first_name: z.string().optional(),
  doctor_in_charge_in_hospital_phone: z.string().optional(),
  employment_status: z.enum(PRIOR_EMPLOYMENT_STATUS).nullish().optional(),
  gender_extended: z.enum(GENDER).optional(),
  health_damage_file_number: z.string().optional(),
  health_damage_origin: z.string().optional(),
  health_damage_present: predicamentSchema.nullish().optional(),
  health_damages_description: z.string().optional(),
  hospital_name_address: z.string().optional(),
  insurance_company_name_address: z.string().optional(),
  insurance_name: z.string().optional(),
  insurance_type: z.enum(HEALTH_INSURANCE_TYPES).nullish().optional(),
  jobcenter_name: z.string().optional(),
  last_employment: z.string().optional(),
  legal_guardian_email: z.string().optional(),
  legal_guardian_house_number: z.string().optional(),
  legal_guardian_phone: z.string().optional(),
  legal_guardian_town: z.string().optional(),
  legal_guardian_type: z.enum(LEGAL_GUARDIAN).optional(),
  legal_guardian_zip_code: z.string().optional(),
  marital_status: z.enum(MARITAL_STATUS).nullish().optional(),
  needs_disability_equipment: z.string().optional(),
  needs_disability_equipment_applicable: predicamentSchema.nullish().optional(),
  patient_bank_account_holder: z.string().optional(),
  patient_bank_iban: z.string().optional(),
  patient_bank_name: z.string().optional(),
  patient_birth_name: z.string().optional(),
  patient_birthdate: z.number().optional(),
  patient_city: z.string().optional(),
  patient_first_name: z.string().optional(),
  patient_last_name: z.string().optional(),
  patient_maiden_name: z.string().optional(),
  patient_nationality: z.string().optional(),
  patient_phone_number: z.string().optional(),
  patient_street_housenumber: z.string().optional(),
  patient_unable_to_work_before_hospitalization: predicamentSchema
    .nullish()
    .optional(),
  patient_unable_to_work_before_hospitalization_date: z.number().optional(),
  patient_zipcode: z.string().optional(),
  pension_insurance_company_name: z.string().optional(),
  postal_code_doctor: z.string().optional(),
  preferred_rehab_clinic: z.string().optional(),
  prior_employment_status: z.enum(PRIOR_EMPLOYMENT_STATUS).nullish().optional(),
  requested_rehab_service: z.enum(REQUESTED_REHAB_SERVICE).optional(),
  requested_rehab_service_type_insured: z
    .enum(REQUESTED_REHAB_SERVICE_TYPE)
    .optional(),
  requested_rehab_service_type_relatives: z
    .enum(REQUESTED_REHAB_SERVICE_TYPE)
    .optional(),
  retirement_pension_received: z.string().optional(),
  retirement_pension_received_applicable: predicamentSchema
    .nullish()
    .optional(),
  risk_of_incapacity_caused_by_accident_third_person: predicamentSchema
    .nullish()
    .optional(),
  send_documents_per_email: z.boolean().optional(),
  send_documents_per_email_description: z.string().optional(),
  social_worker_name_number: z.string().optional(),
  special_payments_from_civil_services: predicamentSchema.nullish().optional(),
  statutory_pension_insurance_number: z
    .string()
    .max(PENSION_INSURANCE_NUMBER_CHARACTER_LIMIT)
    .optional(),
  street_house_number_doctor: z.string().optional(),
  structured_treatment_plan: z.string().optional(),
  third_party_request: predicamentSchema.nullish().optional(),
  town_doctor: z.string().optional(),
  unemployment_benefit_type_2: predicamentSchema.nullish().optional(),
  visually_impaired_document: z
    .array(z.enum(VISUALLY_IMPAIRED_DOCUMENT))
    .optional(),
});
